var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-select"},[_c('Button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.handleSelect}},[_vm._v(_vm._s(_vm.langMap.selectFile[_vm.lang]))]),_c('input',{ref:"fileRef",staticClass:"file-input",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.handleFileChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }